/**
 * Presentation maths for the admin Onboarding view. Pure so the awkward cases —
 * an empty cohort, a question nobody answered — are pinned by tests rather than
 * discovered as `NaN%` on the page.
 */

/** A count as a share of a total, to one decimal place. Dash when there is no total. */
export const formatShare = (count: number, total: number): string =>
	total === 0 ? '—' : `${((count / total) * 100).toFixed(1)}%`

/**
 * Bar length as a percentage of the row, scaled against the largest count in the
 * distribution so the busiest option fills the row and the rest read relative to
 * it. Zero when nothing was picked, which keeps an all-zero distribution flat
 * instead of dividing by zero.
 */
export const barWidth = (count: number, max: number): number =>
	max <= 0 ? 0 : (count / max) * 100

/**
 * The intents cell. `null` means the person never reached the question; `[]`
 * means they answered but nothing readable came through, which is a data problem
 * rather than a non-answer — so the two never render the same.
 */
export const formatIntents = (intents: string[] | null): string => {
	if (intents === null) return '—'
	return intents.length > 0 ? intents.join(', ') : '(none)'
}
